import { render, staticRenderFns } from "./stakeholderHealth.vue?vue&type=template&id=2ab6fb66&scoped=true&"
import script from "./stakeholderHealth.vue?vue&type=script&lang=js&"
export * from "./stakeholderHealth.vue?vue&type=script&lang=js&"
import style0 from "./stakeholderHealth.vue?vue&type=style&index=0&id=2ab6fb66&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab6fb66",
  null
  
)

export default component.exports